export default __webpack_public_path__ + "static/media/secret_5.c3476a98.jpg";